import {Overlay} from '@angular/cdk/overlay';
import {registerLocaleData} from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule, TitleStrategy} from '@angular/router';
import {AppComponent} from '@app/app.component';
import {routes} from '@app/app.routes';
import {metaReducers, reducers} from '@app/reducers';
import {RefreshTokenInterceptor} from '@app/services/refresh-token.interceptor';
import {ErrorInterceptor, TokenInterceptor} from '@app/services/token.interceptor';
import {ConfigService} from '@config/config.service';
import {CustomPaginator} from '@config/paginator-configuration';
import {LoginEffects} from '@login/ngrx/login.effects';
import {LoginService} from '@login/services/login.service';
import {EffectsModule} from '@ngrx/effects';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {StompRService} from '@stomp/ng2-stompjs';
import {ToastrModule} from 'ngx-toastr';
import {environment} from '@environments/environment';
import {StoreModule} from '@ngrx/store';
import {toastConfig} from '@config/toastr.confit';
import localeUa from '@angular/common/locales/uk';
import localeUaExtra from '@angular/common/locales/extra/uk';
import {NgxDaterangepickerMd} from "ngx-daterangepicker-material";
import {CustomPageTitleStrategy} from "@main/CustomPageTitleStrategy";
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/uk';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(quarterOfYear);
dayjs.extend(localizedFormat);
dayjs.locale('uk');


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + Date.now());
}

registerLocaleData(localeUa, localeUaExtra);

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    exports: [],
    imports: [MatDialogModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatMenuModule,
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes),
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(toastConfig),
        EffectsModule.forRoot([LoginEffects]),
        StoreModule.forRoot(reducers, { metaReducers }),
        NgxDaterangepickerMd.forRoot(),
        StoreRouterConnectingModule.forRoot({
            stateKey: 'router'
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 50,
            logOnly: environment.production,
            connectInZone: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })], providers: [
        LoginService,
        ConfigService,
        StompRService,
        provideEnvironmentNgxMask(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RefreshTokenInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'uk-UA'
        },
        {
            provide: MatPaginatorIntl,
            useValue: CustomPaginator()
        },
        {
            provide: TitleStrategy,
            useClass: CustomPageTitleStrategy
        },
        MatDialog,
        Overlay,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
